/* Shopify Forms renders notices in a shadow root, outside the theme stylesheet.
   Keep this presentation enhancement separate from form/consent/captcha handling. */
(() => {
  'use strict';
  const noticeSelector = '[class*="_formDisclaimer_"]';
  const defaultNotice = 'View our privacy policy and terms of service.';
  const css = `
    :host .ew-form-notice.ew-form-notice {
      margin: 10px 0 0; padding: 0; font-size: 12px; line-height: 1.6;
      color: #6b6258; text-align: left; overflow-wrap: anywhere;
    }
    :host .ew-form-notice.ew-form-notice p { margin: 0; padding: 0; font: inherit; color: inherit; }
    :host .ew-form-notice.ew-form-notice a {
      font: inherit; color: inherit; text-decoration: underline;
      text-underline-offset: 2px;
    }
  `;

  function enhance(root) {
    if (!root.querySelector('style[data-ew-form-notices]')) {
      const style = document.createElement('style');
      style.dataset.ewFormNotices = '';
      style.textContent = css;
      root.append(style);
    }
    root.querySelectorAll(noticeSelector).forEach(notice => {
      notice.classList.add('ew-form-notice');
      // Only link the known default copy; leave any future custom consent copy intact.
      if (notice.textContent.trim() !== defaultNotice) return;
      const paragraph = document.createElement('p');
      const link = (text, href) => {
        const anchor = document.createElement('a');
        anchor.textContent = text;
        anchor.href = href;
        return anchor;
      };
      paragraph.append('View our ', link('privacy policy', '/policies/privacy-policy'),
        ' and ', link('terms of service', '/policies/terms-of-service'),
        '. This site is protected by hCaptcha and the hCaptcha ',
        link('Privacy Policy', 'https://hcaptcha.com/privacy'), ' and ',
        link('Terms of Service', 'https://hcaptcha.com/terms'), ' apply.');
      notice.replaceChildren(paragraph);
    });
  }

  const bound = new WeakSet();
  function attach() {
    let attached = false;
    document.querySelectorAll('shopify-forms-embed').forEach(embed => {
      const root = embed.shadowRoot;
      if (!root) return;
      attached = true;
      if (bound.has(root)) return;
      bound.add(root);
      enhance(root);
      // The app may mount or replace its notice after initialisation.
      new MutationObserver(() => enhance(root)).observe(root, {childList: true, subtree: true});
    });
    return attached;
  }
  // App embeds load asynchronously. Stop checking after 20 seconds; the original
  // app notice remains usable if Shopify changes its implementation.
  let attempts = 0;
  function initialise() {
    if (!attach() && ++attempts < 40) setTimeout(initialise, 500);
  }
  initialise();
})();
